import { Button, type ButtonProps } from '../button'

type PopoverButtonProps = Omit<ButtonProps, 'variant' | 'full'>

export function PopoverButton({ children, ...props }: PopoverButtonProps) {
  return (
    <div className="pt-fourpulse">
      <Button.Root full variant="neutral-secondary" {...props}>
        {children}
      </Button.Root>
    </div>
  )
}

PopoverButton.displayName = 'PopoverButton'
